import { useEffect, useState } from "react";

const PRODUCTION_HOSTS = new Set([
  "realpranks.com",
  "www.realpranks.com",
  "rosscreations.com",
  "www.rosscreations.com",
]);

/** True when the app is served from a local dev host. SSR-safe (returns false without `window`). */
export function isLocalDevHost(): boolean {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname.toLowerCase();
  return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
}

/**
 * Hosts where Google reCAPTCHA domain verification is expected to pass.
 * Firebase preview channels (`{site}--{channel}-{hash}.web.app`) and the
 * `realpranks-test` hosting site are not registered in the reCAPTCHA admin.
 */
export function isProductionHost(): boolean {
  if (typeof window === "undefined") return false;
  return PRODUCTION_HOSTS.has(window.location.hostname.toLowerCase());
}

/** Skip client reCAPTCHA on localhost, preview channels, and test hosts. */
export function shouldBypassRecaptcha(): boolean {
  if (typeof window === "undefined") return false;
  return !isProductionHost();
}

/**
 * Client-only localhost detection for conditional UI. Returns false on the
 * server and on the first client render so SSR markup matches hydration.
 */
export function useIsLocalDevHost(): boolean {
  const [localDev, setLocalDev] = useState(false);

  useEffect(() => {
    setLocalDev(isLocalDevHost());
  }, []);

  return localDev;
}

/** Client-only; false on the server and first render so SSR markup hydrates. */
export function useShouldBypassRecaptcha(): boolean {
  const [bypass, setBypass] = useState(false);

  useEffect(() => {
    setBypass(shouldBypassRecaptcha());
  }, []);

  return bypass;
}
